import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import MonitorHeart from "@mui/icons-material/MonitorHeart";
import Sync from "@mui/icons-material/Sync";
import ToggleOn from "@mui/icons-material/ToggleOn";
import Warehouse from "@mui/icons-material/Warehouse";
import { ResourceProps } from "@refinedev/core";

// "Admin" group shown above the seller menu for users with an admin role (see
// App). Kept separate from navigationItems so the seller menu is untouched.
// New admin pages are added as children of the "admin" group.
export const getAdminResources = (): ResourceProps[] => [
  {
    name: "admin",
    meta: {
      icon: <AdminPanelSettings />,
    },
  },
  {
    name: "feature-flags",
    list: "/admin/feature-flags",
    show: "/admin/feature-flags/:key",
    meta: {
      parent: "admin",
      icon: <ToggleOn />,
    },
  },
  {
    name: "admin-warehouses",
    list: "/admin/warehouses",
    meta: {
      parent: "admin",
      icon: <Warehouse />,
    },
  },
  {
    name: "admin-product-sync",
    list: "/admin/product-sync",
    meta: {
      parent: "admin",
      icon: <Sync />,
    },
  },
  {
    name: "admin-system",
    list: "/admin/system",
    meta: {
      parent: "admin",
      icon: <MonitorHeart />,
    },
  },
];
